import { HISTORY_FAILED, HISTORY_FETCHING, HISTORY_SUCCESS } from '../constants'

const initialState = {
    result: null,
    isFetching: false,
    isError: false
}

export default (state = initialState, { type, payload }) => {
    switch (type) {
        case HISTORY_FETCHING:
            return { ...state, result: null, isFetching: true, isError: false}
        case HISTORY_SUCCESS:
            return { ...state, result: payload, isFetching: false, isError: false}
        case HISTORY_FAILED:
            return { ...state, result: null, isFetching: false, isError: true}
        default:
            return state
    }
}
